module.exports = __webpack_public_path__ + "static/img/overseas_bg.aa2f9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/programme/images/overseas_bg.png
// module id = SNQL
// module chunks = 1